import { Controller } from "@hotwired/stimulus";
import { application } from "src/stimulus/application";
import { ChartSpec, debounce, renderChart } from "src/site/recharts";

// Site::PrefectureArea::GraphBasicLine::Component の Stimulus コントローラ。
// landIeul: components/uiParts/GraphBasic の LineChart。データはサーバから受け取るので fetch は不要。
// GraphBasic は tick の fontSize を指定しないため既定の 1rem、Line の type も未指定なので linear になる。

interface ChartValue {
  data: Array<Record<string, number | string>>;
  series: Array<{
    key: string;
    name: string;
    stroke: string;
    fill: string;
    strokeWidth: number;
    unit: string;
  }>;
  xKey: string;
  xUnit?: string;
  yUnit?: string;
  yDomain?: [number, number];
  yTicks?: number[];
}

class SitePrefectureAreaGraphBasicLineController extends Controller<HTMLElement> {
  static values = { chart: Object };

  declare readonly chartValue: ChartValue;

  private onResize?: () => void;

  connect(): void {
    this.onResize = debounce(() => this.draw());
    window.addEventListener("resize", this.onResize);
    this.draw();
  }

  disconnect(): void {
    if (this.onResize) window.removeEventListener("resize", this.onResize);
  }

  private draw(): void {
    renderChart(this.element, this.spec());
  }

  private spec(): ChartSpec {
    const v = this.chartValue;
    return {
      kind: "line",
      data: v.data,
      xKey: v.xKey,
      xPadding: { left: 20, right: 20 },
      xTickFontSize: "1rem",
      xUnit: v.xUnit,
      yTickFontSize: "1rem",
      yUnit: v.yUnit,
      yDomain: v.yDomain,
      yTicks: v.yTicks,
      yLocaleString: true,
      curve: "linear",
      legendWrapperStyle: {
        "font-size": "15px",
        "margin-left": "20px",
        "line-height": "40px",
      },
      series: v.series,
      containerStyle: "width:100%;height:100%;min-width:0",
    };
  }
}

application.register(
  "site--prefecture-area--graph-basic-line",
  SitePrefectureAreaGraphBasicLineController,
);
